import MaintenanceComponent from './Maintenance';

export const Maintenance = MaintenanceComponent;
